import React, { useEffect, useState, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CartContext } from '@/App';
import { CheckCircle, Clock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const [paymentStatus, setPaymentStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(`${API}/payment/checkout-status/${sessionId}`);
      
      if (response.data.payment_status === 'paid') {
        setPaymentStatus('success');
        clearCart();
      } else if (attempts < 5) {
        // Retry after 2 seconds
        setTimeout(() => {
          setAttempts(prev => prev + 1);
          checkPaymentStatus();
        }, 2000);
      } else {
        setPaymentStatus('pending');
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentStatus('error');
    }
  };

  if (paymentStatus === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Clock className="mx-auto mb-4 animate-spin text-green-600" size={64} />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Vérification du paiement...</h2>
          <p className="text-gray-600">Veuillez patienter</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <CheckCircle className="mx-auto mb-6 text-green-600" size={80} data-testid="success-icon" />
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-testid="success-title">
            Paiement réussi !
          </h1>
          
          <p className="text-gray-600 mb-6">
            Votre commande a été confirmée avec succès. Vous allez recevoir un email de confirmation.
          </p>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <p className="text-green-800 font-semibold">
              Merci pour votre commande !
            </p>
            <p className="text-green-700 text-sm mt-1">
              Vous pouvez suivre votre commande dans la section "Mes Commandes"
            </p>
          </div>

          <div className="space-y-3">
            <Link
              to="/orders"
              className="block w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition"
              data-testid="view-orders-btn"
            >
              Voir mes commandes
            </Link>
            
            <Link
              to="/"
              className="block w-full border border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 transition"
            >
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;